import { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import OfflineExpenseUpload from '../components/offline-expense-upload';
import Modal from '../components/modal';
import { savePreSigninLocation } from './signin-redirect';

const isAuthenticated = () => {
  return !!window.localStorage.getItem('jwt');
};

function ProtectedRoute({ data }) {
  const location = useLocation();
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  useEffect(() => {
    if (!authenticated) {
      savePreSigninLocation(location);
    }
  }, [authenticated, location]);

  if (!authenticated) {
    return <Navigate to="/signin" replace />;
  }

  const passwordExpiredRedirect = data?.password_expired === true && location.pathname !== '/settings';

  if (passwordExpiredRedirect) {
    return (
      <Modal
        title={data.t.read('attention')}
        okAction={() => navigate('/settings')}
        okText="OK"
        data={data}
      >
        {data.t.read('password_expired_redirect_message')}
      </Modal>
    );
  }

  return <><Outlet/><OfflineExpenseUpload/></>;
}

export default inject('data')(observer(ProtectedRoute));
